import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Sends a GA4 page_view event on every route change.
 * Single Page Applications don't trigger full page reloads, so we need to
 * inform Google Analytics manually when the user navigates client-side.
 */
const GA_ID = 'G-K656E4E0L8';

const AnalyticsListener = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', GA_ID, {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsListener;
